import React, { useContext } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { IWithErrorHandlingProps, withErrorHandling } from '../withErrorHandling';
import { IUseApiProps } from '../useApi';
import GoUpdatesCls from './GoUpdatesCls';
import { OrbUserContext } from '../OrbUserContext';


export interface IGoUpdatesProps extends IUseApiProps, IWithErrorHandlingProps {
}

const GoUpdates = (props: IGoUpdatesProps) => {
    const { userPermissions, userContext, orbConfig } = useContext(OrbUserContext);
    return (
        <ErrorBoundary>
            <GoUpdatesCls
                userPermissions={userPermissions}
                orbConfig={orbConfig}
                userContext={userContext}
                {...props}
            />
        </ErrorBoundary>
    );

};

export default withErrorHandling(GoUpdates);
